export const DOCUMENT_NAMES = {
  SALARY_RECEIPT: "สำเนาสลิปเงินเดือน",
  STATEMENT: "statement-",
  NCB: `เอกสาร "NCB" (National Credit Bureau )`,
  MOU: "หนังสือรับรองสถานะและเงินเดือน",
  OTHER: "เอกสารอื่นๆ",
  BOOK_BANK: "หน้า book bank",
  ID_CARD: "สำเนาบัตรประชาชน",
  HOUSE_LICENSE: "สำเนาทะเบียนบ้าน",
  PASSPORT: "สำเนาหนังสือเดินทาง",
  VISA: "สำเนาวีซ่า",
  WORK_PERMIT: "สำเนาทร.38/1 หรือ เอกสาร Work permit",
  E_SIGN: "e_sign_file",
};
